var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "photo-upload"
  }, [_c('div', {
    staticClass: "photo-upload__wrapper"
  }, [_vm._l(_vm.images, function (el, i) {
    return _c('div', {
      key: i,
      staticClass: "photo-upload__photo-wrapper",
      on: {
        "click": function ($event) {
          return _vm.onClick(i);
        }
      }
    }, [_c('img', {
      ref: "photo",
      refInFor: true,
      staticClass: "photo-upload__photo",
      attrs: {
        "src": el
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "photo-upload__photo-remove",
      attrs: {
        "title": "Удалить"
      },
      on: {
        "click": function ($event) {
          $event.stopPropagation();
          return _vm.removeImage(i);
        }
      }
    })]);
  }), _vm._v(" "), _c('div', {
    staticClass: "photo-upload__photo-wrapper photo-upload__file",
    class: [{
      'photo-upload_disabled': _vm.disabled
    }],
    on: {
      "drop": function ($event) {
        $event.preventDefault();
        return _vm.handleFileDrop.apply(null, arguments);
      }
    }
  }, [_c('label', {
    staticClass: "photo-upload__file-wrapper"
  }, [_c('div', {
    staticClass: "photo-upload__file-icon"
  }), _vm._v(" "), _c('input', {
    staticClass: "photo-upload__file-input",
    attrs: {
      "type": "file",
      "accept": _vm.accept,
      "disabled": _vm.disabled,
      "multiple": _vm.multiple
    },
    on: {
      "change": _vm.handleFileChange
    }
  })])])], 2), _vm._v(" "), _c('Photoswipe', {
    attrs: {
      "is-open": _vm.openPhotoSwipe,
      "items": _vm.items,
      "options": {
        index: _vm.photoSwipeIndex
      }
    },
    on: {
      "close": function ($event) {
        _vm.openPhotoSwipe = false;
      }
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }